/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { TranslationContext } from '@coursera-web/ondemand-translation';

import { InlineNotification, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/peer';

const styles = {
  bannerWrapper: () => css`
    margin-top: var(--cds-spacing-150);
  `,
};

export const TranslationFailedMessage = () => {
  const context = React.useContext(TranslationContext);

  if (!context?.progressTracker.hasError) {
    return null;
  }

  return (
    <div css={styles.bannerWrapper}>
      <InlineNotification severity="error">
        <Typography2 variant="subtitleMedium" color="error" component="span">
          {_t("The content couldn't be translated.")}
        </Typography2>
      </InlineNotification>
    </div>
  );
};
